import { z } from 'zod'

import { m } from '@maestro/commerce-blocks/schemas/helpers'

export const favoriteListCreateFormSchema = z.object({
  // See favorite-list-rename-form.schema for why the value is trimmed first.
  favoriteListName: z.string().trim().min(1, m('favorite-list-name.required')),
  sharedWithOrganization: z.boolean().optional(),
  editableByOthers: z.boolean().optional(),
})

export type FavoriteListCreateFormData = z.infer<
  typeof favoriteListCreateFormSchema
>
